<script>
import {mergeData} from 'vue-functional-data-merge'
import {InlineError} from '../InlineError'

export default {
  name: 'Labelled',
  components: {
    InlineError
  },
  props: {
    label: {
      type: String
    },
    error: {
      type: String
    },
    helpText: {
      type: String
    },
    helpTextHtml: {
      type: String
    },
    required: {
      type: Boolean
    }
  },
  functional: true,
  render(h, {data, props, slots, $style}) {
    const labelMarkup = props.label && h('div', {
      class: $style.label
    }, [props.label])

    const errorMarkup = props.error && h(InlineError, {
      props: {
        message: props.error
      }
    })

    const helpText = props.helpText && h('div', {
      class: $style.helpText
    }, [props.helpText])

    const helpTextHtml = props.helpTextHtml && h('div', {
      class: $style.helpText,
      domProps: {
        innerHTML: props.helpTextHtml
      }
    })

    return h('div', mergeData(data, {
      class: 'UIElement'
    }), [
      labelMarkup,
      slots().default,
      errorMarkup,
      helpText,
      helpTextHtml
    ])
  }
}
</script>

<style lang="scss" module>
.label {
  margin-bottom: 4px;
  font-size: 14px;
  line-height: 20px;
}
.error {
  margin-top: 4px;
  color: #bf0711;
  font-size: 14px;
  line-height: 20px;
}
.helpText {
  margin-top: 4px;
  color: #637381;
  font-size: 14px;
  line-height: 20px;
}
.required {
  font-weight: bold;
}
</style>
